module.exports = __webpack_public_path__ + "img/icon2.55cb0ca8.png";